import i18n from '@i18n';
import React from 'react';

export default function RadarLoading() {
    return (
        <div className="nikeone-matchtracker-preload-wrap">
            <h3>{i18n('commons.term.loading')}</h3>
        </div>
    );
}
